import { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Icon from '@mdi/react';
import { mdiAccountStar, mdiCalendar, mdiChartBar, mdiSchool } from "@mdi/js";
import { AnimationDefinition, motion, useAnimationControls } from "framer-motion";

import { ColorsStyle } from "../../config/colors";
import { useNavigate } from "react-router-dom";

export default function LandingFuncionalidades(){

	const navigate = useNavigate();
	const [funcionalidade, setFuncionalidade] = useState(1);

	const funcionalidade1 = useAnimationControls();
	const funcionalidade2 = useAnimationControls();
	const funcionalidade3 = useAnimationControls();
	const funcionalidade4 = useAnimationControls();

	function handleMouseEnter(item: number){
		if(item!==funcionalidade){
			let animation1: AnimationDefinition = {opacity: 0, x: -200, scale: 0.75};
			let animation2: AnimationDefinition = {opacity: 0, x: -200, scale: 0.75};
			let animation3: AnimationDefinition = {opacity: 0, x: -200, scale: 0.75};
			let animation4: AnimationDefinition = {opacity: 0, x: -200, scale: 0.75};

			if(item===1){
				funcionalidade1.set({x: 100, scale: 1});
				animation1 = {opacity: 1, x: 0};
			}
			if(item===2){
				funcionalidade2.set({x: 100, scale: 1});
				animation2 = {opacity: 1, x: 0};
			}
			if(item===3){
				funcionalidade3.set({x: 100, scale: 1});
				animation3 = {opacity: 1, x: 0};
			}
			if(item===4){
				funcionalidade4.set({x: 100, scale: 1});
				animation4 = {opacity: 1, x: 0};
			}
			
			funcionalidade1.start(animation1, {duration: 0.2, type: 'tween'});
			funcionalidade2.start(animation2, {duration: 0.2, type: 'tween'});
			funcionalidade3.start(animation3, {duration: 0.2, type: 'tween'});
			funcionalidade4.start(animation4, {duration: 0.2, type: 'tween'});

			setFuncionalidade(item);
		}
	}

	return (
		<Container fluid id="funcionalidades" className="py-5">
			<Container>
				<Row>
					<Col className="d-flex flex-column justify-content-center align-items-stretch align-items-lg-start" lg={7}>
						<motion.div initial={{x: -50}} whileInView={{x: 0}} transition={{type: "tween", duration: 0.5, delay: 0.0}} viewport={{margin: "-50px"}} className="fs-1 fw-bold mb-4">Barbearia modernizada,<br/>gestão simplificada.</motion.div>
					
						<motion.div initial={{x: -50}} whileInView={{x: 0}} transition={{type: "tween", duration: 0.5, delay: 0.2}} viewport={{margin: "-50px"}} className="d-flex align-items-center flex-row mb-4 cursor-pointer" onMouseEnter={()=>{ handleMouseEnter(1); }}>
							<div className={`d-flex flex-column flex-shrink-0 justify-content-center align-items-center rounded-circle me-3 ${funcionalidade===1 && "text-primary"}`} style={{backgroundColor: ColorsStyle.Grey700, width: 80, height: 80}}>
								<Icon path={mdiCalendar} size={2} />
							</div>
							<div>
								<div className={`mb-1 fs-5 fw-bold ${funcionalidade===1 && "text-primary"}`}>Agendamento Online</div>
								<div className="mb-1 fs-6" style={{color: ColorsStyle.Gainsboro}}>Ofereça conveniência aos clientes, eliminando esperas desnecessárias. Maximize sua agenda, reduza falhas e impulsione a satisfação do cliente.</div>
							</div>
						</motion.div>
						
						<motion.div initial={{x: -50}} whileInView={{x: 0}} transition={{type: "tween", duration: 0.5, delay: 0.2}} viewport={{margin: "-50px"}} className="d-flex align-items-center flex-row mb-4 cursor-pointer" onMouseEnter={()=>{ handleMouseEnter(2); }}>
							<div className={`d-flex flex-column flex-shrink-0 justify-content-center align-items-center rounded-circle me-3 ${funcionalidade===2 && "text-primary"}`} style={{backgroundColor: ColorsStyle.Grey700, width: 80, height: 80}}>
								<Icon path={mdiChartBar} size={2} />
							</div>
							<div>
								<div className={`mb-1 fs-5 fw-bold ${funcionalidade===2 && "text-primary"}`}>Gestão Completa</div>
								<div className="mb-1 fs-6" style={{color: ColorsStyle.Gainsboro}}>Controle comissões dos barbeiros, receba lembretes automáticos de horários agendados e obtenha insights valiosos com relatórios detalhados.</div>
							</div>
						</motion.div>

						<motion.div initial={{x: -50}} whileInView={{x: 0}} transition={{type: "tween", duration: 0.5, delay: 0.2}} viewport={{margin: "-50px"}} className="d-flex align-items-center flex-row mb-4 cursor-pointer" onMouseEnter={()=>{ handleMouseEnter(3); }}>
							<div className={`d-flex flex-column flex-shrink-0 justify-content-center align-items-center rounded-circle me-3 ${funcionalidade===3 && "text-primary"}`} style={{backgroundColor: ColorsStyle.Grey700, width: 80, height: 80}}>
								<Icon path={mdiSchool} size={2} />
							</div>
							<div>
								<div className={`mb-1 fs-5 fw-bold ${funcionalidade===3 && "text-primary"}`}>Ambiente de Ensino</div>
								<div className="mb-1 fs-6" style={{color: ColorsStyle.Gainsboro}}>Com a funcionalidade "Academy", aprimore suas habilidades em gestão, marketing e atendimento ao cliente. Fornecemos cursos gratuitos e práticos para impulsionar sua barbearia.</div>
							</div>
						</motion.div>
						
						<motion.div initial={{x: -50}} whileInView={{x: 0}} transition={{type: "tween", duration: 0.5, delay: 0.2}} viewport={{margin: "-50px"}} className="d-flex align-items-center flex-row mb-4 cursor-pointer" onMouseEnter={()=>{ handleMouseEnter(4); }}>
							<div className={`d-flex flex-column flex-shrink-0 justify-content-center align-items-center rounded-circle me-3 ${funcionalidade===4 && "text-primary"}`} style={{backgroundColor: ColorsStyle.Grey700, width: 80, height: 80}}>
								<Icon path={mdiAccountStar} size={2} />
							</div>
							<div>
								<div className={`mb-1 fs-5 fw-bold ${funcionalidade===4 && "text-primary"}`}>Exclusividade Garantida</div>
								<div className="mb-1 fs-6" style={{color: ColorsStyle.Gainsboro}}>Aplicativo Web Exclusivo sem custo adicional. Mantenha sua identidade, conquiste mais clientes e otimize experiências.</div>
							</div>
						</motion.div>

						<motion.div initial={{x: -50}} whileInView={{x: 0}} transition={{type: "tween", duration: 0.5, delay: 0.2}} viewport={{margin: "-50px"}}>
							<motion.div whileHover={{scale: 1.05}} whileTap={{scale: 0.95}}>
								<Button size="lg" className="px-4 py-3 fw-medium" onClick={()=>{ navigate("/funcionalidades") }}>Conheça todas funcionalidades</Button>
							</motion.div>
						</motion.div>
					</Col>
					<Col lg={5} className="d-none d-lg-flex justify-content-center align-items-center position-relative overflow-hidden">
						<motion.img animate={funcionalidade1} initial={{opacity: 1, x: 0}} src="funcionalidade1.webp" loading="lazy" alt="Logo Tribo Barber" style={{position: 'absolute', maxWidth: '100%', maxHeight: 'calc(100% - 86px)'}}/>
						<motion.img animate={funcionalidade2} initial={{opacity: 0, x: 500}} src="funcionalidade2.webp" loading="lazy" alt="Logo Tribo Barber" style={{position: 'absolute', maxWidth: '100%', maxHeight: 'calc(100% - 86px)'}}/>
						<motion.img animate={funcionalidade3} initial={{opacity: 0, x: 500}} src="funcionalidade3.webp" loading="lazy" alt="Logo Tribo Barber" style={{position: 'absolute', maxWidth: '100%', maxHeight: 'calc(100% - 86px)'}}/>
						<motion.img animate={funcionalidade4} initial={{opacity: 0, x: 500}} src="funcionalidade4.webp" loading="lazy" alt="Logo Tribo Barber" style={{position: 'absolute', maxWidth: '100%', maxHeight: 'calc(100% - 86px)'}}/>
					</Col>
				</Row>
			</Container>
		</Container>
	)
}